<template>
  <div id="autoMapWrap">
    <div id="autoMapForm">
      <Form
        :label-width="60"
        ref="autoItem"
        :model="autoItem"
        :rules="ruleValidate"
      >
        <FormItem label="起点" prop="startAdd">
          <div @click="nowAdd = 1">
            <search-add @adds="reAdds1"></search-add>
          </div>
        </FormItem>
        <FormItem label="终点" prop="endAdd">
          <div @click="nowAdd = 2">
            <search-add @adds="reAdds1"></search-add>
          </div>
        </FormItem>
      </Form>
      <Row type="flex" justify="end">
        <Col span="24">
          <div class="btn-wrap">
            <Button type="primary" @click="autoDraw('autoItem')"
              >生成路线</Button
            >
            <Button @click="lineOk" type="success">确定线路</Button>
          </div>
        </Col>
      </Row>
    </div>
    <div id="autoMap"></div>
  </div>
</template>
<script>
var map, route;
var path = [];
export default {
  data() {
    return {
      nowAdd: 1,
      autoItem: {
        startAdd: "",
        endAdd: "",
        adds: [],
        start: {},
        end: {},
      },
      ruleValidate: {
        startAdd: { required: true, message: "必填项" },
        endAdd: { required: true, message: "必填项" },
      },
    };
  },
  methods: {
    loadMap() {
      map = new AMap.Map("autoMap", {
        resizeEnable: true,
        center: this.center,
        zoom: 10,
      });

      //标记中心点
    },
    reAdds1(v) {
      if (this.nowAdd == 1) {
        this.autoItem.startAdd = v.address;
        this.autoItem.start = {
          lng: v.x,
          lat: v.y,
        };
      } else {
        this.autoItem.endAdd = v.address;
        this.autoItem.end = {
          lng: v.x,
          lat: v.y,
        };
      }
    },
    autoDraw(name) {
      //this.lineClear();
      this.$refs[name].validate((valid) => {
        if (valid) {
          map.clearMap();
          var path = [];
          path.push([this.autoItem.start.lng, this.autoItem.start.lat]);
          path.push([this.autoItem.end.lng, this.autoItem.end.lat]);

          map.plugin("AMap.DragRoute", function () {
            route = new AMap.DragRoute(map, path, AMap.DrivingPolicy.LEAST_FEE); //构造拖拽导航类
            route.search(); //查询导航路径并开启拖拽导航
            console.log(route.getPath());
          });
        }
      });
    },
    lineOk() {
      path = route.getRoute();
      if (path.length == 0) {
        this.$Message.error("无线路数据");
      } else {
        this.$emit("autoData", path);
      }

      path = [];
    },
  },
  mounted() {
    this.loadMap();
  },
};
</script>
<style lang="">
#autoMap {
  width: 100%;
  height: 100%;
}
#autoMapForm {
  width: 390px;
  height: 200px;
  position: absolute;
  left: 10px;
  top: 10px;
  z-index: 2;
  background: white;
  padding: 15px;
}
#autoMapWrap {
  width: 100%;
  height: 100%;
  position: relative;
}
</style>


// WEBPACK FOOTER //
// src/components/map/autoLine.vue